import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next'

import { AppLanguage } from '~/types/locale'
import Topics from '~/MathTopics/components/Topics'
import TopicDetails from '~/MathTopics/components/TopicDetails'
import LoaderSkeleton from '~/shared/components/LoaderSkeleton'
import { MathTopicData } from '~/MathTopics/types/math-topic.type'
import { useGetMathTopicsDataQuery } from '~/MathTopics/redux/math-topics.api'

export default function MathTopics(): React.ReactElement {
  const { t } = useTranslation('mathTopics')
  const { locale } = useRouter()

  const { data: mathTopicData, isLoading } = useGetMathTopicsDataQuery({
    language: (locale || AppLanguage.EN) as string,
  })

  return (
    <>
      <div className="bg-white w-11/12 md:w-full max-w-[904px] h-auto mx-auto mt-7 mb-52 px-2.5 md:px-8 py-7 rounded-2.5 text-light-fade">
        <h1 className="mb-10 text-8 leading-8 not-italic font-bold tracking-wider text-center text-black-light-fade">
          {t('mainMathTopics')}
        </h1>

        {isLoading ? (
          <LoaderSkeleton className="h-28 w-full rounded-2.5 my-4" rows={5} />
        ) : (
          <>
            <Topics mathTopicData={mathTopicData as MathTopicData} />

            <div className="h-px bg-purple-light-deep mb-7" />

            <TopicDetails mathTopicData={mathTopicData as MathTopicData} />
          </>
        )}
      </div>
    </>
  )
}
